import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Menu, MenuItem, Stack } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { addToast as addToastAction } from "../../actions/toasts";
import {
  indexImportances as indexImportancesAction,
  createImportance as createImportanceAction,
  indexImportancesFilters as indexImportancesFiltersAction,
  updateImportance as updateImportanceAction,
  deleteImportance as deleteImportanceAction
} from "../../actions/importances";
import {
  listImportances as listImportancesSelector,
  listImportancesFilters as listImportancesFiltersSelector,
} from "../../selectors/importances";
import { isLoading as isLoadingSelector } from "../../selectors/loaders";

import EditImportanceModal from "../ImportancesModal/EditImportanceModal";
import DeleteObjectsModal from "../GlobalObjectsModal/deleteObjectsModal";

import DataTable from "../DataTable";

class Importances extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentImportance: null,

      selectedImportancesIds: [],

      modalOpened: false,
      menuAnchorEl: null,
      openedMenu: null,
      deleteModalOpened: false
    };

    this.deleteImportance = this.deleteImportance.bind(this);
  }

  setSelectedImportancesIds = newSelection => {
    this.setState({
      selectedImportancesIds: newSelection,
    });
  };

  /* Menus methods */

  setMenuAnchorEl = target => {
    this.setState({
      menuAnchorEl: target
    });
  };

  setOpenedMenu = menuId => {
    this.setState({
      openedMenu: menuId
    });
  };

  openMenu = (event, menuId) => {
    this.setMenuAnchorEl(event.currentTarget);
    this.setOpenedMenu(menuId);
  };
  closeMenu = menuId => {
    this.setMenuAnchorEl(null);
    this.setOpenedMenu(menuId);
  };

  /* Edit Modal */

  openEditModal = currentImportance => {
    this.setState({
      currentImportance,
      modalOpened: true
    });
  };

  closeEditModal = () => {
    this.setState({
      currentImportance: null,
      modalOpened: false
    });
  };

  closeDeleteModal = () => {
    this.setState({
      deleteModalOpened: false
    });
  };

  /* Add Modal */

  async deleteImportance(selectedImportances) {
    const { deleteImportance, addToast } = this.props;

    if (selectedImportances.length > 0) {
      let deleted = 0;

      for (let i = 0; i < selectedImportances.length; i += 1) {
        const selectedImportance = selectedImportances[i];
        const ret = await deleteImportance(selectedImportance);

        if (ret.isSuccess) {
          deleted += 1;
        }
      }

      if (deleted === selectedImportances.length) {
        addToast("success", "Success", "Importance(s) successfully deleted!");
      } else if (deleted === 0) {
        addToast("error", "Error", "Importance(s) cannot be deleted. Try again.");
      } else {
        addToast("warning", "Warning", "Some importance(s) cannot be deleted. Try again.");
      }

      this.setState({
        selectedImportancesIds: [],
        deleteModalOpened: false
      });
    }
  }

  /* Modal */

  render() {
    const {
      currentImportance,
      modalOpened,
      selectedImportancesIds,
      menuAnchorEl,
      openedMenu,
      deleteModalOpened
    } = this.state;

    const {
      importances,
    } = this.props;

    const menuOpen = Boolean(menuAnchorEl);

    return (
      <Stack spacing={2}>
        <div>
          <Button
            id="actions-button"
            sx={{
              borderColor: "primary.smokeBorder",
            }}
            variant="outlined"
            aria-controls={menuOpen && openedMenu === "actions-menu" ? "actions-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen && openedMenu === "actions-menu" ? "true" : undefined}
            disableElevation
            onClick={e => this.openMenu(e, "actions-menu")}
            endIcon={<KeyboardArrowDownIcon />}
            disabled={ selectedImportancesIds.length <= 0 }
          >
            Actions
          </Button>
          <Menu
            MenuListProps={{
              "aria-labelledby": "actions-button",
            }}
            id="actions-menu"
            anchorEl={menuAnchorEl}
            open={menuOpen && openedMenu === "actions-menu"}
            onClose={() => this.closeMenu()}
          >
            <MenuItem
              sx={{
                color: "red"
              }}
              onClick={() => {
                this.closeMenu();
                this.setState({
                  deleteModalOpened: true
                });
              }}
              disableRipple
            >
              Delete selected importances
            </MenuItem>
          </Menu>
        </div>
        <div style={{ height: "calc(100vh - 270px)", minHeight: "160px" }}>
          <DataTable
            cols={[
              { headerName: "Id", field: "id", flex: 1 },
              { headerName: "Name", field: "name", flex: 1 },
              { headerName: "Modified", field: "updated_at", flex: 1 }
            ]}
            data={importances}
            onRowClick={id => this.openEditModal(id)}
            onRowSelectionModelChange={this.setSelectedImportancesIds}
            checkboxSelection
          />
        </div>

        {/* MODAL */}

        <EditImportanceModal
          currentId={currentImportance?.id}
          modalOpened={modalOpened}
          closeEditModal={this.closeEditModal}
        />

        <DeleteObjectsModal
          selectedIds={selectedImportancesIds}
          modalOpened={deleteModalOpened}
          deleteObjects={this.deleteImportance}
          closeDeleteModal={this.closeDeleteModal}
          name="Importance(s)"
        />
      </Stack>
    );
  }
}

Importances.propTypes = {
  importances: PropTypes.arrayOf(PropTypes.object).isRequired,

  deleteImportance: PropTypes.func.isRequired,
  addToast: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    importances: listImportancesSelector(state),
    importancesFilters: listImportancesFiltersSelector(state),

    isImportancesLoading: isLoadingSelector(state, indexImportancesAction.toString()),
    isImportancesCreating: isLoadingSelector(state, createImportanceAction.toString()),
    isImportancesEditing: isLoadingSelector(state, updateImportanceAction.toString())
  };
}

const mapDispatchToProps = {
  indexImportances: indexImportancesAction,
  indexImportancesFilters: indexImportancesFiltersAction,
  updateImportance: updateImportanceAction,
  deleteImportance: deleteImportanceAction,
  addToast: addToastAction
};

export default connect(mapStateToProps, mapDispatchToProps)(Importances);
